/**
 * @generated SignedSource<<0bbc039c92ebf3b5f4db0197880b4bd2>>
 * @relayHash c78c24ccfea65d024c1681405fc16940
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 655f8681f6878752f03c9433ed501b192e0197f2e27b417f4ea55d05f54efbd0

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCapacityQuery } from './ui_jiraCapacityQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCapacityQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "655f8681f6878752f03c9433ed501b192e0197f2e27b417f4ea55d05f54efbd0",
    "metadata": {},
    "name": "ui_jiraCapacityQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
